import "./stylesExportToXlsxButton.css";

import { useState } from "react";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import { DownloadOutlined } from "@ant-design/icons";

const writeXlsx = (rows, filename) => {
  if (!rows || rows.length === 0) return;
  const worksheet = XLSX.utils.json_to_sheet(rows);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Dados");
  const excelBuffer = XLSX.write(workbook, {
    bookType: "xlsx",
    type: "array",
  });
  const fileData = new Blob([excelBuffer], {
    type: "application/octet-stream",
  });
  saveAs(fileData, filename);
};

/**
 * @param {{
 *   data?: Array<Record<string, unknown>>,
 *   filename?: string,
 *   loadData?: (() => Promise<Array<Record<string, unknown>>>) | null,
 * }} props
 */
const ExportToXlsxButton = ({ data = [], filename = "", loadData = null }) => {
  const [isLoading, setLoading] = useState(false);

  const hasStaticData = Array.isArray(data) && data.length > 0;
  const disabled = isLoading || (!loadData && !hasStaticData);

  const onClick = async () => {
    if (disabled) return;
    if (loadData) {
      setLoading(true);
      try {
        const rows = await loadData();
        writeXlsx(rows, filename);
      } finally {
        setLoading(false);
      }
      return;
    }
    writeXlsx(data, filename);
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label="Download"
      className={`export-to-xlsx-button ${disabled ? "disabled" : ""}`}
    >
      <DownloadOutlined className="download-icon" />
    </button>
  );
};

export default ExportToXlsxButton;
